<template>
  <div class="border border-radius border-box padding">
    <div class="font-size-large font-bold border-bottom padding-bottom padding-left">{{ $t('homePage.nolaNovelData.title') }}</div>
    <div class="grid">
      <div class="border-right">
        <div class="margin-bottom padding-left">{{ $t('homePage.nolaNovelData.yesterdayPV') }}</div>
        <div class="font-bold font-size-large padding-left">{{ lastDayPV }} {{ $t('homePage.nolaNovelData.pv') }}</div>
      </div>
      <div>
        <div class="margin-bottom padding-left">{{ $t('homePage.nolaNovelData.bookmarkCount') }}</div>
        <div class="font-bold font-size-large padding-left">{{ allBookmark }} {{ $t('homePage.nolaNovelData.items') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { UserClient } from "@/lib/clients";
import {
  AnalyticsDataType,
  AnalyticsFromNolaNovel,
  AnalyticsItem,
  AnalyticsTerm,
  UserFromNolaNovel,
} from "@/lib/models";
import { format, subDays } from "date-fns";
import Vue from "vue";

const userClient = new UserClient();

export default Vue.extend<Data, Methods, Computed, Props>({
  async created() {
    const { nolaNovel } = await userClient.checkConnectedOtherServices();

    if (!nolaNovel.result) return;

    let userFromNolaNovel = this.$store.getters["nolaNovelModule/user"];

    if (!userFromNolaNovel) userFromNolaNovel = await this.$store.dispatch("nolaNovelModule/fetchUser");

    await this.$store.dispatch("nolaNovelModule/fetchAnalytics", [
      {
        targetId: userFromNolaNovel.id,
        type: AnalyticsDataType.PV_EPISODE,
        term: AnalyticsTerm.DAILY,
        date: format(subDays(new Date(), 1), "YYYYMMDD"),
      },
      {
        targetId: userFromNolaNovel.id,
        type: AnalyticsDataType.BOOKMARK,
        term: AnalyticsTerm.ALL,
      },
    ]);

    this.existsUserOnNolaNovel = true;
  },
  data() {
    return {
      existsUserOnNolaNovel: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters["nolaNovelModule/user"];
    },
    analytics() {
      return this.$store.getters["nolaNovelModule/analytics"];
    },
    lastDayPV() {
      const { user } = this;
      if (!user) return 0;

      const lastDay = format(subDays(new Date(), 1), "YYYYMMDD");
      const pv = this.$store.getters["nolaNovelModule/analyticsById"](`PV#EPISODE#DAILY#${lastDay}`, user.id) as
        | AnalyticsItem
        | undefined;
      return pv ? pv.count : 0;
    },
    allBookmark() {
      const { user } = this;
      if (!user) return 0;

      const bookmark = this.$store.getters["nolaNovelModule/analyticsById"]("BOOKMARK#ALL", user.id) as
        | AnalyticsItem
        | undefined;
      return bookmark ? bookmark.count : 0;
    },
  },
});

interface Props {}

interface Data {
  existsUserOnNolaNovel: boolean;
}

interface Computed {
  user: UserFromNolaNovel;
  analytics: AnalyticsFromNolaNovel[];
  lastDayPV: number;
  allBookmark: number;
}

interface Methods {}
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--color-border);
  color: var(--color-text-normal);
}

.border-radius {
  border-radius: var(--radius-sm);
}

.border-box {
  box-sizing: border-box;
}

.padding {
  padding: 10px;
}

.font-size-large {
  font-size: var(--font-size-md);
}

.font-bold {
  font-weight: var(--font-weight-bold);
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  margin-top: 15px;
}

.border-right {
  border-right: 2px solid var(--color-border);
}

.border-bottom {
  border-bottom: 2px solid var(--color-border);
}

.padding-bottom {
  padding-bottom: 5px;
}

.padding-left {
  padding-left: 5px;
}

.margin-bottom {
  margin-bottom: 10px;
}
</style>
